/**
 * Uploads a bug report's screenshot and diagnostics before the issue is filed.
 * A transient failure (5xx or dropped connection) is retried once; a 4xx is not,
 * because the file itself was refused. It never throws: a report without
 * attachments is better than no report.
 */

export interface UploadedBugAttachments {
  screenshotUrl?: string;
  diagnosticsUrl?: string;
}

const RETRY_DELAY_MS = 800;

export async function uploadBugAttachments(
  url: string,
  headers: HeadersInit,
  form: FormData,
  options: { retryDelayMs?: number } = {},
): Promise<UploadedBugAttachments> {
  const delay = options.retryDelayMs ?? RETRY_DELAY_MS;

  for (let attempt = 0; attempt < 2; attempt++) {
    try {
      const res = await fetch(url, { method: 'POST', headers, body: form });
      if (res.ok) {
        const data = (await res.json()) as UploadedBugAttachments;
        return { screenshotUrl: data.screenshotUrl, diagnosticsUrl: data.diagnosticsUrl };
      }
      console.warn('[SupportModal] attachment upload failed', res.status);
      if (res.status < 500) return {};
    } catch (err) {
      console.warn('[SupportModal] attachment upload errored', err);
    }
    if (attempt === 0) await new Promise(resolve => setTimeout(resolve, delay));
  }
  return {};
}
